<template>
  <span
    class="i-layout-header-trigger i-layout-header-trigger-min i-layout-header-trigger-in"
  >
    <Notification
      :wide="isMobile"
      :badge-props="badgeProps"
      class="i-layout-header-notice"
      :class="{ 'i-layout-header-notice-mobile': isMobile }"
      @on-clear="handleClear"
    >
      <Icon slot="icon" custom="i-icon i-icon-notification" />
      <NotificationTab title="待办" name="todo" :scroll-to-load="false">
        <NotificationItem
          v-for="(item, index) in todoList"
          :key="index"
          :title="formatMsgType(item.msgType)"
          :content="item.description"
          @on-item-click="operation(item)"
        />
      </NotificationTab>
    </Notification>

    <!-- 抽屉 - 查看投票详情 -->
    <Drawer
      title="投票详情"
      :closable="false"
      v-model="voteDetailDrawer"
      width="1000"
      transfer
    >
      <VoteDetail ref="voteDetailRef"></VoteDetail>
    </Drawer>
  </span>
</template>
<script>
import { mapState } from "vuex";

import { GetTodoList, DelTodoInfo } from "@/api/account.js";
import { GetVoteDetail } from "@/api/chain.js";

// 投票详情
import VoteDetail from "../../../pages/chain/management/components/management-vote-detail.vue";

export default {
  name: "iHeaderNotice",
  data() {
    return {
      badgeProps: {
        offset: [20, 0],
      },
      todoLoading: false,
      todoList: [],
      voteDetailDrawer: false,
      msgTypeList: [
        {
          label: "投票管理",
          value: "vote",
        },
      ],
    };
  },
  computed: {
    ...mapState("admin/layout", ["isMobile"]),
  },
  components: {
    VoteDetail,
  },
  mounted() {
    this.getNotice();
  },
  methods: {
    // 获取待办信息
    async getNotice() {
      let res = await GetTodoList();
      if (res && res.code == 200) {
        this.todoList = res.data.todoInfoList;
      }
    },
    formatMsgType(cellValue) {
      let item = this.msgTypeList.find((item) => item.value == cellValue);
      return item ? item.label : "";
    },
    async operation({ msgId, orgId }) {
      let voteDetail = [];
      let currentCertOrgId = orgId;

      // // 根据voteId，获取投票详情
      let args = {
        voteId: msgId,
        orgId,
      };
      let res = await GetVoteDetail(args);
      if (res && res.code == 200) {
        voteDetail = res.data;
        this.$refs.voteDetailRef.init(voteDetail, currentCertOrgId);
        this.voteDetailDrawer = true;
      }
      // 以下为测试数据
      // this.$refs.voteDetailRef.init(voteDetail, currentCertOrgId);
      // this.voteDetailDrawer = true;
    },
    async handleClear() {
      let eventIdList = [];
      this.todoList.forEach((item) => {
        eventIdList.push(item.eventId);
      });

      let args = {
        eventIdList,
      };

      let res = await DelTodoInfo(args);
      if (res && res.code == 200) {
        // 清除成功，重新获取数据
        this.getNotice();
      }
    },
  },
};
</script>
